import { Box, Skeleton } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, primitive } from 'styles/constants';

export const PaymentSelection = Box.withConfig({
  marginTop: '$4',
  paddingBottom: '$8',
});

export const DisclaimerWrapper = withTypography({
  color: primitive.$greyOne,
  fontFamily: 'body',
  fontSize: 'xs',
  mt: '$0',
  mr: '$0',
  mb: '$4',
  ml: '$0',
  px: '$1',
  py: '$0',
  textAlign: 'center',
});

export const CartPriceTooLow = Box.withConfig({
  _text: {
    textAlign: 'center',
    color: getDesignToken('alert-warning-background'),
  },
  padding: '$2',
  borderWidth: 0,
  borderColor: getDesignToken('alert-warning-background'),
  margin: 0,
});

export const ErrorContainer = Box.withConfig({
  marginTop: '$4',
  backgroundColor: '#fae7ea',

  _text: {
    textAlign: 'center',
  },
});

export const ErrorMessage = withTypography({
  mx: '$8',
  my: '$0',
  px: '$0',
  color: primitive.$fieryRed,
  style: { paddingVertical: 11 },
});

export const SignUpToContinueDisclaimer = withTypography({
  color: primitive.$greyOne,
  fontSize: 'sm',
  textAlign: 'center',
  mb: '$8',
  style: { fontWeight: primitive.$fontWeightNormal },
});

export const WarningContainer = Box.withConfig({
  paddingTop: '$6',
  paddingBottom: '$3',
  paddingX: 0,
  marginRight: '$3',
});

export const SkeletonStyled = Skeleton.withConfig({
  testID: 'currency-line-skeleton',
  height: '$4',
  width: '120px',
  alignSelf: 'center',
  color: primitive.$greyFour,
  borderRadius: 'full',
  mb: '$3',
});

export const TotalContainer = Box.withConfig({
  mb: '$4',
  flexDirection: 'row',
  focusable: true,
});

export const IconContainer = Box.withConfig({
  ml: '$1',
});
